<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
<table
	mat-table
	class="w-full"
	matSort
	matSortDisableClear="true"
	multiTemplateDataRows
	[class.table-layout-fixed]="layoutFixed"
	[trackBy]="trackBy"
	[matSortActive]="sortActive"
	[matSortDirection]="sortDirection"
	[matSortStart]="sortStart"
	[dataSource]="dataSource"
  [ngClass]="{'sm-row-height': smallRowHeight}"
  (matSortChange)="onSortChange($event)"
>
	<ng-container matColumnDef="selection">
		<th mat-header-cell style="width: 50px" class="selection-cell" *matHeaderCellDef>
			<ng-container *ngIf="selectAllMenu; else defaultTpl">
				<div
					class="selection-trigger"
					[class.selection-trigger--disabled]="!dataWithoutDisabledSelections.length"
					[matMenuTriggerFor]="selectAllMenu"
					[matMenuTriggerDisabled]="!dataWithoutDisabledSelections.length"
				>
					<mat-pseudo-checkbox
						[state]="selectedRowsArray | selectAllCheckboxState : dataWithoutDisabledSelections"
						[disabled]="!dataWithoutDisabledSelections.length"
					></mat-pseudo-checkbox>
				</div>
			</ng-container>

			<ng-template #defaultTpl>
				<div
					class="selection-trigger"
					[class.selection-trigger--disabled]="!dataWithoutDisabledSelections.length"
					(click)="dataWithoutDisabledSelections.length ? onToggleMasterSelection() : null"
				>
					<mat-pseudo-checkbox
						[state]="selectedRowsArray | selectAllCheckboxState : dataWithoutDisabledSelections"
						[disabled]="!dataWithoutDisabledSelections.length"
					></mat-pseudo-checkbox>
				</div>
			</ng-template>
		</th>
		<td mat-cell *matCellDef="let row" class="align-top selection-cell">
			<mat-checkbox
				[checked]="selectedRowsSet.has(row)"
				[disabled]="disabledRowsMap.get(row) || false"
				[matTooltip]="disabledRowsMap.get(row) ? disabledTooltipsMap.get(row) : ''"
				matTooltipPosition="above"
				(click)="$event.stopPropagation()"
				(change)="$event ? onToggleSelection(row) : null"
			></mat-checkbox>
		</td>
	</ng-container>

	<ng-container *ngFor="let column of columns">
		<ng-container *ngIf="(cellTemplates | findCellTemplate: column) as template; else columnsTpl">
			<ng-container [matColumnDef]="column.dataField" [sticky]="column.isSticky">
				<th class="uppercase {{column.headerCellClasses}}"
					mat-header-cell
					*matHeaderCellDef
					[disabled]="!column.allowSorting"
					[style.width]="column.width"
					[style.minWidth]="column.width"
					[matTooltip]="column.captionTooltip"
					[matTooltipPosition]="column.captionTooltipPosition || 'above'"
					mat-sort-header> {{column | headerCellCaption}} </th>
				<td mat-cell *matCellDef="let element; let i = dataIndex;" [class]="column.cellClasses">
					<ng-container
						*ngTemplateOutlet="
							template.templateRef;
							context: {
							  $implicit: element,
							  expanded: expandedRows.has(element),
							  dataField: column.dataField,
							  index: i,
              }"
					></ng-container>
				</td>
			</ng-container>
		</ng-container>

		<ng-template #columnsTpl>
			<ng-container [matColumnDef]="column.dataField" [sticky]="column.isSticky">
				<th class="uppercase {{column.headerCellClasses}}"
					mat-header-cell
					*matHeaderCellDef
					[disabled]="!column.allowSorting"
					[style.width]="column.width"
					[style.minWidth]="column.width"
					[matTooltip]="column.captionTooltip"
					mat-sort-header
				> {{column | headerCellCaption}} </th>
				<td mat-cell *matCellDef="let element" class="truncate {{column.cellClasses}}">
					<ng-container *ngIf="column.cellTemplate; else defaultColumnsTpl">
						<ng-container [ngSwitch]="column.cellTemplate">
							<ng-container *ngSwitchCase="dataTableTemplatesEnum.DateTemplate">
								{{element[column.dataField] | date: (column.dateFormat || dateFormat)}}
							</ng-container>

							<ng-container *ngSwitchCase="dataTableTemplatesEnum.NumberTemplate">
								{{element[column.dataField] | number}}
							</ng-container>

							<ng-container *ngSwitchCase="dataTableTemplatesEnum.VisibilityTemplate">
								{{element[column.dataField] ? 'Team' : 'Private' }}
							</ng-container>

							<ng-container *ngSwitchCase="dataTableTemplatesEnum.BooleanTemplate">
                <fa-icon
                  *ngIf="element[column.dataField]; else falseTpl"
                 class="si-icon" [icon]="['fal', 'check']"></fa-icon>

                <ng-template #falseTpl>
                  <fa-icon class="si-icon" [icon]="['fal', 'xmark']"></fa-icon>
                </ng-template>
							</ng-container>

							<ng-container *ngSwitchDefault>
								<ng-container *ngTemplateOutlet="defaultColumnsTpl"></ng-container>
							</ng-container>

						</ng-container>
					</ng-container>

					<ng-template #defaultColumnsTpl>
						{{element[column.dataField]}}
					</ng-template>
				</td>
			</ng-container>
		</ng-template>
	</ng-container>

	<!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
	<ng-container matColumnDef="expandedDetail">
		<td mat-cell *matCellDef="let element" [attr.colspan]="columnNames.length">
			<div class="expanded-detail" [@detailExpand]="expandedRows.has(element) ? 'expanded' : 'collapsed'">
				<ng-container *ngTemplateOutlet="rowDetailTemplate?.templateRef; context: { $implicit: element, expanded: expandedRows.has(element) }"></ng-container>
			</div>
		</td>
	</ng-container>

	<tr mat-header-row [class.hidden]="hideHeader" *matHeaderRowDef="columnNames; sticky: stickyHeader"></tr>

  <ng-container matColumnDef="dividerRow">
    <td mat-cell *matCellDef="let row" class="divider-row-cell" [attr.colspan]="columnNames.length"></td>
  </ng-container>

  <tr
    mat-row
    *matRowDef="let row; columns: ['dividerRow']; when: showDivider"
    class="divider-row"
  ></tr>

	<tr
		*matRowDef="let row; columns: columnNames;"
		mat-row
		[class.expandable-row]="rowDetailTemplate"
		[class.cursor-pointer]="rowDetailTemplate"
		[class.font-bold]="rowDetailTemplate && expandedRows.has(row)"
		(click)="onToggleExpansion(row)"
	></tr>

	<ng-container *ngIf="rowDetailTemplate">
		<tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expandable-detail-row"></tr>
	</ng-container>

	<tr class="mat-row" *matNoDataRow>
		<td class="mat-cell border-0" [attr.colspan]="columnNames?.length">
			<p class="mb-0 text-center italic">{{ isLoading ? isLoadingText : noDataText}}</p>
		</td>
	</tr>
</table>
<div *ngIf="isLoadMore" class="py-6">
	<article class="flex justify-center">
		<mat-spinner></mat-spinner>
	</article>
</div>
